export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Estadística Vectores',
    route: 'notices-process-logs',
    icon: 'FileIcon',
  },
]
